export default __webpack_public_path__ + "static/media/i_wdt_c_4.51fe8cbb.mp3";